import { useState, useEffect } from 'react';
import { getLocations } from '../../../services/locationService';
import { getAccountTypes } from '../../../services/accountService';

export const useDataLoading = (addNotification) => {
  // Locations state
  const [locations, setLocations] = useState({
    SDO: [],
    SCHOOL: {
      'Elementary': [],
      'Junior High School': [],
      'Senior High School': [],
      'Integrated School': []
    }
  });
  const [isLoadingLocations, setIsLoadingLocations] = useState(true);

  // Account types state
  const [accountTypes, setAccountTypes] = useState([]);
  const [isLoadingAccountTypes, setIsLoadingAccountTypes] = useState(true);

  // Fetch locations
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setIsLoadingLocations(true);
        const fetchedLocations = await getLocations();
        setLocations(fetchedLocations);
      } catch (error) {
        console.error('Error fetching locations:', error);
        addNotification('error', 'Failed to load locations. Please try again later.');
      } finally {
        setIsLoadingLocations(false);
      }
    };

    fetchLocations();
  }, [addNotification]);

  // Fetch account types
  useEffect(() => {
    const fetchAccountTypes = async () => {
      try {
        setIsLoadingAccountTypes(true);
        const types = await getAccountTypes();
        setAccountTypes(types);
      } catch (error) {
        console.error('Error fetching account types:', error);
        addNotification('error', 'Failed to load account types. Using default options.');
        
        // Fallback account types (matching database seed)
        const fallbackTypes = [
          { id: 1, name: 'DEPED ACCOUNT' },
          { id: 2, name: 'M365 ACCOUNT' },
          { id: 3, name: 'LIS ACCOUNT' },
          { id: 4, name: 'LMS ACCOUNT' },
          { id: 5, name: 'ADOBE ACCOUNT' },
          { id: 6, name: 'DPDS ACCOUNT' }
        ];
        setAccountTypes(fallbackTypes);
      } finally {
        setIsLoadingAccountTypes(false);
      }
    };

    // For now, use fallback types immediately to test the form
    const fallbackTypes = [
      { id: 1, name: 'DEPED ACCOUNT' },
      { id: 2, name: 'M365 ACCOUNT' },
      { id: 3, name: 'LIS ACCOUNT' },
      { id: 4, name: 'LMS ACCOUNT' },
      { id: 5, name: 'ADOBE ACCOUNT' },
      { id: 6, name: 'DPDS ACCOUNT' }
    ];
    setAccountTypes(fallbackTypes);
    setIsLoadingAccountTypes(false);
    
    // Uncomment this to try API call
    // fetchAccountTypes();
  }, [addNotification]);

  return {
    locations,
    isLoadingLocations,
    accountTypes,
    isLoadingAccountTypes
  };
}; 